import { useState } from "react"
import { AppSpan, FlexColumn } from "src/style"

const Menu: React.FC<any> = ({item, handleClick}) => {
    const [isHover, setIsHover] = useState(false)


    return (
        <>
            <FlexColumn
                width="auto" sizeUnit="" rightMargin="5"
                style={{zIndex: 3}}
                onMouseEnter={() => setIsHover(true)}
                onMouseLeave={() => setIsHover(false)}
                onClick={() => handleClick(item)}
            >
                {item.icon(isHover)}
                <AppSpan textSize='1.1' color='#ffffff' topPadding="0.5">{item.title}</AppSpan>
            </FlexColumn>
        </>
    )
}

export default Menu